<template>
  <component :is="isCN ? LogoCn : LogoEn" />
</template>

<script lang="ts" setup>
import LogoCn from "./LogoCn.vue";
import LogoEn from "./LogoEn.vue";

const isCN = !!import.meta.env.VITE_IS_CN;
</script>
